var dotenv = require('dotenv')
var dotenvExpand = require('dotenv-expand')

var myEnv = dotenv.config()
dotenvExpand.expand(myEnv)

//const serverUrl = 'https://preprod.heliocity.io:46107'
//const serverUrl = 'https://staging.heliocity.io:45107'
//const serverUrl = 'https://srvdev.heliocity.io:44107'
//const serverUrl = 'http://0.0.0.0:44107'
const serverUrl = 'https://bck-cloud-beta.heliocity.io:45109'
//const serverUrl = 'https://bck-cloud-v2.heliocity.io'

//const serverUrl = process.env.NODE_ENV === "production"
//? 'https://srvdev.heliocity.io:44105'w
//: 'https://srvdev.heliocity.io:44107'
//    ? 'https://staging.heliocity.io:45105'
//    : 'https://staging.heliocity.io:45107'
// for local
//const serverUrl = process.env.NODE_ENV === "production"
//    ? 'http://0.0.0.0:44107'
//    : 'http://0.0.0.0:44107'
// for aws remove port number from target
//    ? 'https://bck-cloud-beta.heliocity.io:44107'
//    : 'https://bck-cloud-beta.heliocity.io:44107'

export default serverUrl

export const BackendUrl = "https://backend.heliocarto.kapt.mobi"
export const BacklogUrl = "Frozen"
